"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var IStorageAdapter = require("../interfaces/IStorageAdapter");
var LocalStorageAdapter = /*#__PURE__*/function (_IStorageAdapter) {
  function LocalStorageAdapter() {
    var _window;
    var _this;
    (0, _classCallCheck2["default"])(this, LocalStorageAdapter);
    _this = _callSuper(this, LocalStorageAdapter);
    if (!((_window = window) !== null && _window !== void 0 && _window.localStorage)) {
      throw new Error("Local storage is not available for use");
    }
    return _this;
  }
  (0, _inherits2["default"])(LocalStorageAdapter, _IStorageAdapter);
  return (0, _createClass2["default"])(LocalStorageAdapter, [{
    key: "getItem",
    value: function getItem() {
      var _window$localStorage;
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return (_window$localStorage = window.localStorage) === null || _window$localStorage === void 0 ? void 0 : _window$localStorage.getItem.apply(_window$localStorage, args);
    }
  }, {
    key: "setItem",
    value: function setItem() {
      var _window$localStorage2;
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return (_window$localStorage2 = window.localStorage) === null || _window$localStorage2 === void 0 ? void 0 : _window$localStorage2.setItem.apply(_window$localStorage2, args);
    }
  }, {
    key: "removeItem",
    value: function removeItem() {
      var _window$localStorage3;
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return (_window$localStorage3 = window.localStorage) === null || _window$localStorage3 === void 0 ? void 0 : _window$localStorage3.removeItem.apply(_window$localStorage3, args);
    }
  }, {
    key: "clear",
    value: function clear() {
      var _window$localStorage4;
      return (_window$localStorage4 = window.localStorage) === null || _window$localStorage4 === void 0 ? void 0 : _window$localStorage4.clear();
    }
  }, {
    key: "key",
    value: function key() {
      var _window$localStorage5;
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return (_window$localStorage5 = window.localStorage) === null || _window$localStorage5 === void 0 ? void 0 : _window$localStorage5.key.apply(_window$localStorage5, args);
    }
  }]);
}(IStorageAdapter);
module.exports = LocalStorageAdapter;